<template>
  <v-container>
    <h1>Account Data</h1>
    <br>

    <v-card>
      <v-card-title class="blue">
        <span class="headline white--text">Details</span>
        <v-spacer />
      </v-card-title>

      <v-card-text
        v-if="!error"
        class="px-0 py-0"
      >
        <account-detail-component
          v-if="isLoadAccount"
          :account="account"
          @payoutItemCreated="refreshAccount"
        />

        <v-layout
          v-else
          justify-center
        >
          <div class="my-3">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            />
          </div>
        </v-layout>
      </v-card-text>
      <v-alert
        v-else
        :value="error"
        type="error"
        color="error"
      >
        {{ error }}
      </v-alert>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { AccountDetailComponent } from '@/components/baader';

export default {
  name: 'AccountDetails',
  components: {
    'account-detail-component': AccountDetailComponent,
  },
  data() {
    return {
      account: {},
      isLoadAccount: false,
      error: '',
    };
  },
  async mounted() {
    this.refreshAccount();
  },
  methods: {
    ...mapActions([
      'getAccountBySnr',
    ]),
    async refreshAccount() {
      this.isLoadAccount = false;
      try {
        this.account = await this.getAccountBySnr(this.$route.params.snr);
        this.isLoadAccount = true;
      } catch (error) {
        this.account = {};
        this.error = 'No account data found.';
        this.isLoadAccount = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/baader/AccountDetail.vue